// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-styles-components----footer-module---footer---3dt86 src-styles-components----container-module---container---1YJKJ","flex":"src-styles-components----footer-module---flex---3v9D4","texts":"src-styles-components----footer-module---texts---3CcQX","footerLogo":"src-styles-components----footer-module---footerLogo---1N0ih","text":"src-styles-components----footer-module---text---1ydrC","socialContainer":"src-styles-components----footer-module---socialContainer---2MY97","socialItem":"src-styles-components----footer-module---socialItem---15g_B"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/footer.module.scss
// module id = 393
// module chunks = 114276838955818